module.exports = __webpack_public_path__ + "static/media/celso-henrique-estolano-gomes.7d4c03db.jpg";